import { TbX, TbMapPin, TbPolygon, TbLine } from "react-icons/tb";

interface GeometrySelectionModalProps {
  onClose: () => void;
  onGeometryTypeSelected: (type: "point" | "line" | "polygon") => void;
}

export const GeometrySelectionModal: React.FC<GeometrySelectionModalProps> = ({
  onClose,
  onGeometryTypeSelected,
}) => {
  const geometryTypes = [
    {
      type: "point" as const,
      label: "Point",
      description: "Mark Specific Location",
      icon: TbMapPin,
      color: "#374795",
      bgColor: "rgba(55,71,149,0.06)",
    },
    {
      type: "line" as const,
      label: "Line",
      description: "Draw a Path or Route",
      icon: TbLine,
      color: "#00A63E",
      bgColor: "rgba(0,166,62,0.06)",
    },
    {
      type: "polygon" as const,
      label: "Polygon",
      description: "Defined a Bounded Area",
      icon: TbPolygon,
      color: "#8A38F5",
      bgColor: "rgba(138,56,245,0.06)",
    },
  ];

  return (
    <div className="fixed inset-0 bg-black/35 flex items-end justify-center z-[2500] pb-8">
      <div className="bg-white rounded-[20px] p-5 w-full max-w-4xl mx-4 shadow-[0px_0px_24px_0px_rgba(0,0,0,0.08)]">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-[#444444] text-[22px] font-bold mb-1 font-['Open_Sans']">
              Choose Location Type
            </h2>
            <p className="text-[#828282] text-[12px] font-['Open_Sans']">
              Select the type of location you want to mark for the task
            </p>
          </div>
          <button
            onClick={onClose}
            className="bg-gray-100 rounded-[42px] p-[14px] w-[45px] h-[45px] flex items-center justify-center hover:bg-gray-200 transition-colors"
            title="Close"
          >
            <TbX size={16} className="text-[#828282]" />
          </button>
        </div>

        <div className="flex gap-4">
          {geometryTypes.map(
            ({ type, label, description, icon: Icon, color, bgColor }) => (
              <button
                key={type}
                onClick={() => onGeometryTypeSelected(type)}
                className="flex-1 border border-gray-100 rounded-2xl p-2 flex items-center gap-3 hover:bg-gray-50 transition-colors group"
              >
                <div
                  className="w-[42px] h-[42px] rounded-[14px] flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: bgColor }}
                >
                  <Icon size={16} style={{ color: color }} />
                </div>
                <div className="text-left">
                  <h3 className="text-[#444444] text-[18px] font-bold font-['Open_Sans'] leading-[1.4]">
                    {label}
                  </h3>
                  <p className="text-[#828282] text-[12px] font-['Open_Sans'] leading-[1.4]">
                    {description}
                  </p>
                </div>
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
};
